    <div class="modal-header">
        <h5 id="mediaTestTitle" class="modal-title text-center">Media Test (You may skip if you did this earlier today and you have not changed your audio or mic settings!)</h5>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="max-height: 70vh; overflow: auto">
        <div #procteeVideoDiv [ngStyle]="{'display': this.showVideoTestDiv ? 'block' : 'none'}">
            <video #procteeVideo class="proctee-video circle d-block mx-auto" playsinline muted aria-describedby="videoInstructions">Video stream not available.</video>
            <p class="text-center" id="videoInstructions">
                Please adjust your webcam or sitting position to ensure your face is showing inside the circle above
                before you proceed with the examination.
            </p>
            <p class="text-center text-danger">
                ENSURE YOUR FACE IS <strong>CLEARLY VISIBLE</strong> BEFORE YOU PROCEED WITH YOUR EXAMINATION
            </p>
            <p class="text-center text-warning">
                If your face is not visible, please reconfigure your webcam, restart your computer or use a different
                computer. <br /><b>Failure to comply may result in disqualification</b>
            </p>
        </div>
        <div #procteeAudioDiv [ngStyle]="{'display': this.showAudioTestDiv ? 'block' : 'none'}">
            <section aria-labelledby="micTestHeading">
                <h4 id="micTestHeading">Microphone Test</h4>
                <div class="pids-wrapper my-4" aria-hidden="true">
                    <div class="pid"></div>
                    <div class="pid"></div>
                    <div class="pid"></div>
                    <div class="pid"></div>
                    <div class="pid"></div>
                    <div class="pid"></div>
                    <div class="pid"></div>
                    <div class="pid"></div>
                    <div class="pid"></div>
                    <div class="pid"></div>
                </div>

                <p>
                    Click on the <strong>Test Microphone</strong> button and say your name out loud. Play the resulting
                    audio file and confirm you can hear your name.
                </p>
                <button #micTestBtn class="btn btn-sm btn-primary" (click)="recordAudio()"
                    title="Click and say your name out loud" [disabled]="this.recording"
                    [attr.aria-disabled]="recording">Test Microphone</button>

                <div class="my-2">
                    <audio aria-label="Recorded microphone audio playback" #micTestAudio
                        [ngStyle]="{'display': this.recorded ? 'block' : 'none'}" controls></audio>
                </div>

                <div class="form-group">
                    <div class="form-check mt-2" #micTestResponseDiv
                        [ngStyle]="{'display': this.audioPlayEnded ? 'block' : 'none'}">
                        <input class="form-check-input" (change)="MicRes()" type="checkbox" id="micTestResponseCheckbox"
                            #micTestResponse />
                        <label class="form-check-label" for="micTestResponseCheckbox"> Can you hear your name
                            clearly?</label>
                    </div>
                </div>
            </section>

            <section class="mt-4" aria-labelledby="audioTestHeading">
                <h4 id="audioTestHeading">Audio Test</h4>
                <button class="btn btn-sm btn-primary" (click)="startProcteeTestAudio()">Test Audio</button>
                <audio #procteeAudio
                    [ngStyle]="{'display': this.recording ? 'none' : (!this.recording && this.recorded ? 'block' : 'none')}"
                    aria-label="Audio beep test playback">
                    <source src="../../assets/beep.mp3" type="audio/mp3" />
                </audio>
                <div class="form-group">
                    <div class="form-check mt-2" style="display: none;" #audioTestResponseDiv>
                        <input class="form-check-input" (change)="AudioRes()" type="checkbox"
                            id="audioTestResponseCheckbox" #audioTestResponse />
                        <label class="form-check-label" for="audioTestResponseCheckbox"> Did you hear a beep? </label>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="d-flex justify-content-between modal-footer">
        <button type="button" class="btn btn-danger" (click)="skipMediaTest()" aria-label="Skip media test">Skip Media
            Test</button>
        <button *ngIf="!this.mediaTestStarted" #startBtn type="button" class="btn btn-warning"
            (click)="startMediaTest()" aria-label="Start media test">Proceed</button>
        <button *ngIf="this.mediaTestStarted" #finishBtn type="button" class="btn btn-warning"
            (click)="stopProcteeMedia()" [disabled]="!(this.audRes && this.micRes && this.volRes)"
            aria-label="Finish media test and proceed">Proceed</button>
    </div>